export default {
    manage_deletedEquipment: "Equipamiento fue eliminado exitosamente",
    manage_deletedEquipments: "Equipamientos fueron eliminados exitosamente",
    manage_deleteManageEquipment_confirmationMessage:
      "¿Está seguro de que desea eliminar los siguientes Equipamientos?",
    manage_deleteManageEquipment_deleteEquipment: "Eliminar Equipamiento",
    manage_deleteManageEquipment_deleteEquipments: "Eliminar Equipamientos",
  };
  